var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VbDemo',[_c('VbCard',{attrs:{"title":"Static Data","width":"100%"}},[_c('va-data-table-static-data-example')],1),_c('VbCard',{attrs:{"title":"Server-side Pagination","width":"100%"}},[_c('va-data-table-api-mode-example')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }